'use client';
import { NOT_FOUND_PAGE } from '@/common/constant';
import { useEffect } from 'react';

export default function NotFound() {
    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.location.href = NOT_FOUND_PAGE;
        }
    }, []);
    return (
        <html>
            <body></body>
        </html>
    );
}
